module.exports = __webpack_public_path__ + "media/src/assets/images/ai_result-bg-fcd16c2497f359658d72370360af7c5a.jpg";